import { isNull } from 'lodash/fp';

import { ApplicationState } from '../../../../store/types';
import { DatasetDefinition, DocumentSpecificHiddenFields } from '../../../datasets/store/types';
import { RiskField, RiskTolerance, RiskToleranceDataset, SelectedRiskField } from './types';
import { getRiskToleranceRoot } from '../../store/selectors';

export const getAllRiskToleranceDatasets = (state: ApplicationState): RiskToleranceDataset[] => getRiskToleranceRoot(state).allRiskToleranceDatasets;

export const getIsLoading = (state: ApplicationState): boolean => getRiskToleranceRoot(state).isLoading;

export const getRiskToleranceConfig = (state: ApplicationState): RiskTolerance[] | null => getRiskToleranceRoot(state).riskToleranceConfig;

export const getCurrentRiskToleranceConfig = (state: ApplicationState): RiskTolerance[] | null => getRiskToleranceRoot(state).currentRiskToleranceConfig;

export const getDatasetDefinitions = (state: ApplicationState): DatasetDefinition[] => getRiskToleranceRoot(state).definitions;

export const getDocumentHiddenFields = (state: ApplicationState): DocumentSpecificHiddenFields => getRiskToleranceRoot(state).documentHiddenFields;

export const getSelectedRiskField = (state: ApplicationState): SelectedRiskField | null => getRiskToleranceRoot(state).currentRiskField;

export const getCurrentRiskField = (state: ApplicationState): RiskField | null => {
    const selectedRiskField = getSelectedRiskField(state);
    const currentRiskToleranceConfig = getCurrentRiskToleranceConfig(state);
    if (isNull(selectedRiskField) || isNull(currentRiskToleranceConfig)) {
        return null;
    }
    const { datasetId, fieldId } = selectedRiskField;
    return currentRiskToleranceConfig.find(riskDataset => riskDataset.datasetId === datasetId)?.config.find(riskField => riskField.fieldId === fieldId) || null;
};

export const getRiskToleranceHasUpdated = (state: ApplicationState): boolean => getRiskToleranceRoot(state).riskToleranceUpdated;

export const getIsSaving = (state: ApplicationState): boolean => getRiskToleranceRoot(state).isSaving;

export const getUnsavedChangesModalOpen = (state: ApplicationState): boolean => getRiskToleranceRoot(state).unsavedChangesModalOpen;

export const getSelectedRiskToleranceDatasetId = (state: ApplicationState): number | null => getRiskToleranceRoot(state).selectedRiskToleranceDataset;
